export default "__VITE_ASSET__C8_SxJ3G__"